import type { FC } from 'react';
import type { GameLeaderboardEntry } from '@lunit/shared-types';

interface LeaderboardItemProps {
  entry: GameLeaderboardEntry;
  isCurrentUser?: boolean;
}

const formatCoins = (value: string) => {
  const negative = value.startsWith('-');
  const digits = negative ? value.slice(1) : value;
  const formatted = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return negative ? `-${formatted}` : formatted;
};

export const LeaderboardItem: FC<LeaderboardItemProps> = ({ entry, isCurrentUser = false }) => {
  const initials = entry.user.displayName?.charAt(0)?.toUpperCase() || 'P';
  const coins = formatCoins(entry.coins);

  return (
    <div
      className={`flex items-center justify-between p-4 rounded-2xl transition-colors
        ${isCurrentUser ? 'bg-primary/20 border-2 border-primary' : 'bg-white/5 hover:bg-white/10'}`}
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-white/10 font-bold">
          {entry.rank}
        </div>

        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-primary to-secondary text-white font-semibold">
          {initials}
        </div>

        <div className="flex-1 min-w-0">
          <div className="font-semibold truncate">
            {entry.user.displayName}
            {isCurrentUser && <span className="ml-2 text-xs text-primary">(You)</span>}
          </div>
          <div className="text-xs text-gray-400">Level {entry.level}</div>
        </div>
      </div>

      <div className="flex items-center gap-1 font-bold text-primary">🪙 {coins}</div>
    </div>
  );
};

